let partnerJson = require('../data/programpartner.json');

document.addEventListener("DOMContentLoaded", function(event) { 
    generateJudgeData();
});

window.onload = () => {
    handlePageLoaded();
};

function handlePageLoaded(){
    document.getElementsByClassName("loading-screen")[0].style.display = "none";
    document.getElementById("section-programpartners").style.display = "block";
}

async function generateJudgeData() {

    let mediaPartners = document.querySelector("#partner-media");
    let strategicPartners = document.querySelector("#partner-strategic");
    let supportingPartners = document.querySelector("#partner-supporting");
    let synergyPartners = document.querySelector("#partner-synergy");
    let ecosystemPartners = document.querySelector("#partner-ecosystem");
    let programPartners = document.querySelector("#partner-program");
    let container = '';

    partnerJson.forEach(partner => {

        switch (partner.type) {
            case "media":
                container = mediaPartners;
                break;
                
            case "strategic":
                container = strategicPartners;
                break;

            case "supporting":
                container = supportingPartners;
                break;
                
            case "synergy":
                container = synergyPartners;
                break;

            case "ecosystem":
                container = ecosystemPartners;
                break;

            case "program":
                container = programPartners;
                break;
        }

      container.innerHTML += `
        <div class="partner-logo m-4 my-5 p-2 d-flex align-items-center justify-content-center d-flex flex-column align-items-center" data-aos="fade-up" data-aos-duration="800" >
            <a href ="${partner.org_website}"> 
                <img src="${partner.org_logo}" alt="Logo of ${partner.org_name}" class="img-fluid">
            </a>
            <h6 class="mt-3 text-center p-2">${partner.org_name}</h6>
        </div>
      `
    })
}
